import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {LoadingIndicator} from "../../../core/components/loading/loading-indicator";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const BracketsWidgetAsyncComponent = AsyncComponent(async () => import('./brackets-widget' /* webpackChunkName: "brackets-widget" */ ));

export const BracketsWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper isMandatory>
    <React.Suspense fallback={<div className={'brackets-widget-desktop-placeholder'}><LoadingIndicator/></div>}>
      <BracketsWidgetAsyncComponent {...props}/>
    </React.Suspense>
  </ErrorBoundaryWrapper>
}
